import * as Urls from '../constants/Urls';

export const ENTITY_NAME_DASHBOARD = '__DASHBOARD__';

export const EXCEL_FILE_EXTENSION = 'xlsx';

export const TRANSLATE_DATA_COLUMN_VALUES_SEPARATOR = ' + ';

export const SAVED_SEARCHES_ROUTES_WITH_TIMESTAMP = [
  Urls.QUEUE_SETUP_PAGE,
  Urls.APP_MIGRATION_PAGE,
];

export const RECENT_SEARCHES_ALLOWED_SIZE = 5;
